import { getParameters } from '../core'

$.fn.CartForm = function(options) {
  let self = this

  if (self.data('cart-form')) {
    return self.data('cart-form')
  }

  self.options = $.extend(true, {
    main: self.parent(),
    parent: self.parent(),
  }, options)

  self.is_variable = false
  self.is_bundle = false
  self.quantity = undefined
  self.price_display = self.find('.price-display')
  self.variations = {}
  self.current_variation = undefined
  self.buy_now = false
  self.is_gift_card = $('body').hasClass('gift-card-product')

  /*
  * Verrou pré-vente crémant : réponse serveur portant une charge modale → pop-up Wishlist.
  * Retourne true si l'erreur a été prise en charge (le flux normal doit s'arrêter).
  */
  self.handle_lock_modal = function(x, $atcBtn, $atcLabel) {
    if (!(x && x.success === false && x.data && x.data.modal)) return false
    self.unblock()
    $('.gift-card-switch').removeClass('--blocked')
    $atcBtn.removeClass('loading')
    $atcLabel.text($atcLabel.data('original-text') || '')
    if ($.mlmi && $.mlmi.favorites && $.mlmi.favorites.showModal) {
      $.mlmi.favorites.showModal({
        title: x.data.modal.title,
        content: x.data.modal.message,
        ctaText: gourmetsauvage_params.WISHLIST_OK,
        onCta: (closeModal) => {
          closeModal()
        }
      })
    }
    return true
  }

  /*
  * Add to cart
  */
  self.add_to_cart = function(e) {
    e.preventDefault()

    /* Block UI */
    self.block({
      message: null,
      overlayCSS: {
        'background-color': '#ffffff',
      },
    })
    $('.gift-card-switch').addClass('--blocked')

    var $atcBtn = self.buy_now
      ? self.find('.single_buy_now_button')
      : self.find('.single_add_to_cart_button')
    var $atcLabel = $atcBtn.find('.single_add_to_cart_button__label')
    if (!$atcLabel.length) $atcLabel = $atcBtn
    if (!$atcLabel.data('original-text')) {
      $atcLabel.data('original-text', $atcLabel.text().trim())
    }
    $atcBtn.removeClass('added').addClass('loading')
    $atcLabel.text(window.gourmetsauvage_params && window.gourmetsauvage_params.ADDING_TO_CART || 'Ajout au panier...')

    if (self.find('.workshop-variation-form').length) {
      /* Validate total quantity against shared stock */
      var maxStock = parseInt(self.attr('data-stock')) || 0
      var totalQty = 0
      self.find('.workshop-variation-form input.qty').each(function() {
        totalQty += parseInt($(this).val()) || 0
      })
      if (totalQty > maxStock) {
        self.unblock()
        $('.gift-card-switch').removeClass('--blocked')
        $atcBtn.removeClass('loading')
        $atcLabel.text($atcLabel.data('original-text') || '')
        var isEn = $('body').hasClass('language-en')
        var msg = maxStock === 1
          ? (isEn ? 'Only 1 spot remaining for this session.' : 'Il ne reste qu\'une seule place pour cette session.')
          : (isEn ? 'Only ' + maxStock + ' spots remaining for this session.' : 'Il ne reste que ' + maxStock + ' places pour cette session.')
        $.mlmi.cart.errors({ success: false, message: msg })
        return
      }

      var add_item_data = {
        quantity: [],
        product_id: [],
        variation_id: [],
      }

      self.find('.workshop-variation-form').each(function() {
        let $formVar = $(this)
        add_item_data.quantity.push($formVar.find('input.qty').val())
        add_item_data.product_id.push($formVar.find('[name="add-to-cart[]"]').val())
        add_item_data.variation_id.push($formVar.find('[name="add-to-cart-variation[]"]').val())
      })

      /* Post to cart */
      $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart_multiple'),
        type: 'POST',
        data: add_item_data,
        success: function(x) {
          if (self.handle_lock_modal(x, $atcBtn, $atcLabel)) return
          self.unblock()
          $('.gift-card-switch').removeClass('--blocked')
          $atcBtn.removeClass('loading').addClass('added')
          $atcLabel.text(window.gourmetsauvage_params && window.gourmetsauvage_params.ADDED_TO_CART || 'Ajouté au panier')
          $.mlmi.cart.refreshFragments(x)
        },
      })

    } else {
      /* Prepare data to cart */
      let add_item_data = {
        'quantity': self.find('input[name="quantity"]').val(),
        'product_id': self.find('[name="add-to-cart"]').val(),
      }
      if ($('.bundled_item_cart_content .attribute_value_configurable').length) {
        $('.bundled_item_cart_content .attribute_value_configurable').each(function() {
          add_item_data[$(this).find('select').attr('name')] = $(this).find('select').val()
        })
      }
      if (self.find('input[name="variation_id"]').length) {
        add_item_data.variation_id = self.find('input[name="variation_id"]').val()
      }
      if (self.find('input[name="add-gift-bag"]').length && self.find('input[name="add-gift-bag"]').prop('checked')) {
        add_item_data.gift_bag = 1
      }
      if (self.custom_amount && self.custom_amount.hasClass('--visible') && self.custom_amount_input.val()) {
        add_item_data.gc_custom_amount = self.custom_amount_input.val()
      }
      if (self.find('input[name^="bundle_selected_optional_"]').length) {
        self.find('input[name^="bundle_selected_optional_"]').each(function() {
          if ($(this).prop('checked')) {
            add_item_data[$(this).attr('name')] = 1
          }
        })
      }
      let $formVar = self.closest('tr.date-price-table__row');
      if ($formVar.length) {
        add_item_data.quantity = $formVar.find('input.qty').val()
      }

      /* Meta CAPI event_id for deduplication. JS = source de vérité, posé avant le POST
         pour que le pixel browser et le CAPI server partagent le même event_id. */
      var meta_event_id = 'addtocart_' + (add_item_data.variation_id || add_item_data.product_id) + '_' + Math.floor(Date.now()/1000)
      window.__meta_addtocart_event_id = meta_event_id
      add_item_data.meta_event_id = meta_event_id

      /* Post to cart */
      $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
        type: 'POST',
        data: add_item_data,
        success: function(x) {
          if (self.handle_lock_modal(x, $atcBtn, $atcLabel)) return
          self.unblock()
          $('.gift-card-switch').removeClass('--blocked')
          $atcBtn.removeClass('loading').addClass('added')
          $atcLabel.text(window.gourmetsauvage_params && window.gourmetsauvage_params.ADDED_TO_CART || 'Ajouté au panier')
          $.mlmi.cart.refreshFragments(x)
        },
      })
    }

  }

  /*
  * Montant au choix (chèque-cadeau)
  */
  self.apply_custom_amount = function() {
    if (!self.current_variation || !self.current_variation.is_custom_amount) {
      return
    }
    let amount = parseFloat(self.custom_amount_input.val())
    if (isNaN(amount) || amount <= 0) {
      return
    }
    let formatted = amount.toLocaleString('fr-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).replace(',', '.')
    let symbol = '<span class="woocommerce-Price-currencySymbol">$</span>'
    let html = $('body').hasClass('language-en')
      ? '<span class="woocommerce-Price-amount amount"><bdi>' + symbol + formatted + '</bdi></span>'
      : '<span class="woocommerce-Price-amount amount"><bdi>' + formatted + '&nbsp;' + symbol + '</bdi></span>'
    self.current_variation.select_price = '<span class="price">' + html + '</span>'
    self.options.parent.find('.woocommerce-variation-price').html('<span class="price">' + html + '</span>')
  }

  /*
  * Update price
  */
  self.update_price = function() {
    /* Check for quantity select (stock) */
    if (self.quantity == undefined || !self.quantity.length) {
      return
    }

    /* Get quantity and prepare */
    let current_quantity = parseInt(self.quantity.val(), 10)
    self.price_display.find('.price').remove()

    /* Find price display */
    let price_to_display = undefined
    if (self.is_bundle) {
      price_to_display = self.options.main.find('.bundle_button > .price')
    } else if (!self.is_variable) {
      if (self.options.main.find('> .price').first().find('ins').length) {
        price_to_display = self.options.main.find('> .price').first()
      } else {
        price_to_display = self.options.main.find('> .price bdi').first()
      }
      if (!price_to_display.length) {
        price_to_display = self.options.main.find('> .woocommerce-Price-amount bdi').first()
      }
    } else if (self.is_variable && self.current_variation != undefined) {
      price_to_display = self.options.parent.find('.woocommerce-variation-price:not(:empty)').first()
      if (!price_to_display.length) {
        /* WooCommerce vide price_html quand toutes les variations partagent un même
           prix : .woocommerce-variation-price est alors vide. On prend dans ce cas
           le prix HTML de la variation (select_price = get_price_html, qui inclut le
           <del>/<ins> en solde) plutôt que le seul bdi du prix régulier, sinon le
           rabais (prix barré + prix soldé) disparaît. */
        if (self.current_variation.select_price) {
          price_to_display = $('<span class="price">' + self.current_variation.select_price + '</span>')
        } else {
          price_to_display = self.options.parent.find('.woocommerce-variation-add-to-cart .woocommerce-Price-amount bdi').first()
        }
      }
    }
    if (price_to_display != undefined) {
      price_to_display = price_to_display.clone()
    }

    /* Display price on button */
    if (price_to_display != undefined && price_to_display.length) {
      price_to_display = $('<span class="price"></span>').append(price_to_display)
      let currency_format = price_to_display.find('.woocommerce-Price-currencySymbol').first().clone()
      price_to_display.find('.woocommerce-Price-currencySymbol').remove()
      if (price_to_display.find('ins').length) {
        let unit_price = parseFloat(price_to_display.find('ins').text()) * current_quantity,
        unit_regular_price = parseFloat(price_to_display.find('del').text()) * current_quantity
        price_to_display.find('ins').find('bdi').html(unit_price.toLocaleString('fr-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace(',', '.') + '&nbsp;')
        price_to_display.find('del').find('bdi').html(unit_regular_price.toLocaleString('fr-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace(',', '.') + '&nbsp;')
        if ($('body').hasClass('language-en')) {
          price_to_display.find('ins, del').prepend(currency_format)
        } else {
          price_to_display.find('ins, del').append(currency_format)
        }
      } else {
        let unit_price = parseFloat(price_to_display.text()) * current_quantity
        price_to_display.find('bdi').html(unit_price.toLocaleString('fr-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace(',', '.') + '&nbsp;')
        if ($('body').hasClass('language-en')) {
          price_to_display.prepend(currency_format)
        } else {
          price_to_display.append(currency_format)
        }
      }
      self.price_display.prepend(price_to_display)
    }
  }

  /*
  * Initialize interface
  */
  self.initialize_interface = function() {
    /* Quantity input */
    self.find('input.qty').each(function() {
      self.quantity = $(this).Quantity()
      self.quantity.on('change', self.update_price)
    })

    /* Workshop variations: dynamically adjust max across shared stock */
    if (self.find('.workshop-variation-form').length) {
      var $workshopQtys = self.find('.workshop-variation-form input.qty')
      var workshopStock = parseInt(self.attr('data-stock')) || 0
      $workshopQtys.on('change input', function() {
        var total = 0
        $workshopQtys.each(function() { total += parseInt($(this).val()) || 0 })
        $workshopQtys.each(function() {
          var myVal = parseInt($(this).val()) || 0
          $(this).attr('max', Math.max(0, workshopStock - (total - myVal)))
        })
      })
      /* Trigger initial adjustment */
      $workshopQtys.first().trigger('change')
    }

    /* Variable bundle */
    $('.single-product-page__summary .bundled_item_cart_content.variations_form').each(function() {
      $(this).closest('.bundle_form').show()
      $(this).closest('.bundled_product').show()
    })

    /* Select element */
    self.find('table.variations select').each(function() {
      if (self.data('product_variations')) {
        self.is_variable = true
        let get_parameters = getParameters(),
        attribute_name = $(this).attr('name'),
        variations_data = self.data('product_variations')
        variations_data.forEach(function(variation) {
          if (attribute_name in get_parameters) {
            $('select[name="' + attribute_name + '"] option[value="' + get_parameters[attribute_name] + '"]').prop('selected', true)
          }
          let variation_name = variation.attributes[attribute_name]
          self.variations[variation_name] = variation.select_price
        })
      }
    })

    /* Bundle */
    if (self.hasClass('bundle_form')) {
      self.is_bundle = true
    }

    /* Montant au choix (chèque-cadeau) */
    self.custom_amount = self.find('.gc-custom-amount')
    self.custom_amount_input = self.custom_amount.find('input')
    self.custom_amount_input.on('input change', function() {
      self.apply_custom_amount()
      self.update_price()
    })

    /* Variation magic */
    self.find('.single_variation_wrap').on('show_variation', function(e, variation) {
      self.current_variation = variation
      if ('max_qty' in self.current_variation) {
        self.quantity.attr('max', self.current_variation.max_qty)
      }
      if (self.custom_amount.length) {
        if (self.current_variation.is_custom_amount) {
          self.custom_amount.addClass('--visible')
          self.custom_amount_input.prop('required', true)
          self.apply_custom_amount()
        } else {
          self.custom_amount.removeClass('--visible')
          self.custom_amount_input.prop('required', false).val('')
        }
      }
      self.quantity.initialize_limits()
      self.update_price()
    })
    self.find('.single_variation_wrap').on('hide_variation', function() {
      if (self.custom_amount.length) {
        self.custom_amount.removeClass('--visible')
        self.custom_amount_input.prop('required', false)
      }
    })
  }
  $('.gift-card-switch select').change(function() {
    if ($(this).val() != 'current') {
      window.location.href = $(this).val();
      self.block({
        message: null,
        overlayCSS: {
          'background-color': '#ffffff',
        },
      })
      $('.gift-card-switch').addClass('--blocked')
    }
  })

  return function() {
    self.initialize_interface()
    self.update_price()
    self.find('.single_add_to_cart_button, .single_buy_now_button').each(function() {
      var $btn = $(this)
      if ($btn.find('.single_add_to_cart_button__label').length) return
      var firstNode = $btn.contents().filter(function() { return this.nodeType === 3 && this.textContent.trim() !== '' }).first()
      if (!firstNode.length) return
      var label = firstNode[0].textContent.trim()
      firstNode.replaceWith($('<span class="single_add_to_cart_button__label"></span>').text(label))
    })
    self.find('.single_add_to_cart_button').on('click', function() {
      self.buy_now = false
    })
    self.find('.single_buy_now_button').on('click', function() {
      self.buy_now = true
    })
    if (!self.is_gift_card) {
      self.on('submit', self.add_to_cart)
    } else {
      self.on('submit', function() {
        self.block({
          message: null,
          overlayCSS: {
            'background-color': '#ffffff',
          },
        })
        $('.gift-card-switch').addClass('--blocked')
      })
    }
    self.data('cart-form', self)
    $('.gift-card-switch select').val('current')
    return self
  }()
}
